var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack150({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.62,3.71H3.38A2.38,2.38,0,0,1,1,6.09V9.33a2.39,2.39,0,0,1,2.38,2.38h9.24A2.39,2.39,0,0,1,15,9.33V6.09A2.38,2.38,0,0,1,12.62,3.71Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.23,10.71A3.4,3.4,0,0,0,2,8.48V6.94A3.4,3.4,0,0,0,4.23,4.71h7.54A3.4,3.4,0,0,0,14,6.94V8.48a3.4,3.4,0,0,0-2.23,2.23Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack150);
export default __webpack_public_path__ + "static/media/Symbolpack_1_50.393dbf95934bf32439c4df48283ca562.svg";
export { ForwardRef as ReactComponent };